import { gql } from "@apollo/client";

export const GET_ROLES = gql`
  query GetRoles($offset: Int64, $query: String, $limit: Int64 = 100) {
    role {
      pagination(filters: { query: $query }, pagination: { limit: $limit, offset: $offset }) {
        roles {
          id
          code
          name
          description
        }
        paginationData {
          total
        }
      }
    }
  }
`;

export const GET_ROLES_WITH_PERMISSION_CODES = gql`
  query GetRolesWithPermissionCodes($offset: Int64, $query: String, $limit: Int64 = 100) {
    role {
      pagination(filters: { query: $query }, pagination: { limit: $limit, offset: $offset }) {
        roles {
          id
          name
          permissions {
            id
            code
          }
        }
        paginationData {
          total
        }
      }
    }
  }
`;

export const GET_ROLE_DETAIL = gql`
  query GetRoleDeatil($id: ID!) {
    role {
      get(id: $id) {
        code
        name
        description
        permissions {
          name
          code
          id
          level
          parentId
        }
        fullPermissions {
          id
          code
          name
          parentId
          level
          isChecked
        }
      }
    }
  }
`;
